import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "CourierDriverLicenses" }
const _hoisted_2 = {
  key: 0,
  class: "select-none text-sm text-gray-400"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-start"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mt-6 flex items-start justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_uploader = _resolveComponent("file-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.driverLicenses.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " У курьера нет прикрепленных документов "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driverLicenses, (license, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: license.url,
              class: _normalizeClass(["py-2 px-4 border border-gray-200 rounded text-blue-500 flex items-center select-none", { 'mt-4': i !== 0 }])
            }, [
              _hoisted_4,
              _createElementVNode("a", {
                class: "ml-2 font-medium",
                href: license.url,
                target: "_blank"
              }, _toDisplayString(_ctx.getFileName(license)), 9, _hoisted_5),
              (!_ctx.disabled && !_ctx.loading && _ctx.isCanDelete)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-times ml-4 cursor-pointer",
                    onClick: ($event: any) => (_ctx.onDeleteFile(license))
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_file_uploader, {
        placeholder: "Загрузить",
        accept: "image/*,application/pdf",
        multiple: "",
        loading: _ctx.loading || _ctx.state.is_loading,
        disabled: _ctx.disabled,
        onChange: _ctx.onUploadFiles
      }, null, 8, ["loading", "disabled", "onChange"])
    ])
  ]))
}